<template>
  <el-scrollbar wrap-class="scrollbar-wrapper">
    <el-menu
      :show-timeout="200"
      :default-active="$route.path"
      mode="vertical"
      background-color="#304156"
      text-color="#bfcbd9"
      active-text-color="#409EFF"
      router
    >
      <!--放logo-->
      <el-menu-item index="0" style="pointer-events: none; height: 40px">
        <img src="@/assets/logo.png" alt="" style="width: 150px; display: block; margin-top: 20px">
      </el-menu-item>
      <el-menu-item index="/administration/index" disabled>
        <i class="el-icon-house"></i>
        <span slot="title">首页</span>
      </el-menu-item>
      <el-menu-item index="/administration/users">
        <i class="el-icon-user"></i>
        <span slot="title">用户管理</span>
      </el-menu-item>
      <el-menu-item index="/administration/product">
        <i class="el-icon-s-cooperation"></i>
        <span slot="title">产品管理</span>
      </el-menu-item>
      <el-menu-item index="/administration/download">
        <i class="el-icon-download"></i>
        <span slot="title">下载管理</span>
      </el-menu-item>
      <el-menu-item index="/administration/about">
        <i class="el-icon-warning-outline"></i>
        <span slot="title">公司信息管理</span>
      </el-menu-item>
    </el-menu>
  </el-scrollbar>
</template>

<script>
export default {
  name: 'SideBar'
}
</script>

<style scoped>

</style>
